import { BUDGETS_REQUEST_FAIL, BUDGETS_REQUEST_SUCCESS } from '../action.types';
import initialState from '../initial.state';

export default function(state = initialState.budgets, action) {
  switch (action.type) {
    case BUDGETS_REQUEST_SUCCESS:
      return { ...action.payload };
    case BUDGETS_REQUEST_FAIL:
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/budget/budgets.reducer.js